import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
//outsource
import { Row, Col, Layout, Card } from "antd";
import { URL } from "../00_Nav/url";
//components
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import LayoutHeader from "../00_Nav/layout/layout_header";
//redux
import { useDispatch, useSelector } from "react-redux";

//sample
import { REPORT_MENU } from "../../store/string";
//style
import "./style.css";
import LayoutFooter from "../00_Nav/layout/layout_footer";

const { Content } = Layout;

const ReportScreen = () => {
  // -------------------------- VAR --------------------------
  const navigate = useNavigate();
  const breadCrumb = [
    { title: "Home", url: URL.home},
    { title: "Report", url: URL.report },
  ];
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();

  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[20, 20]} style={{ marginTop: 20 }}>
        {REPORT_MENU?.map((item) => renderItem({ item }))}
      </Row>
    );
  };

  const renderItem = ({ item }) => {
    const key = item?.key;
    const title = item?.title;
    const icon = item?.icon;
    const route = item?.route;
    return (
      <Col align="center" key={key} xl={4} lg={4} md={8} xs={12}>
        <Card
          className="card-menu-report"
          onClick={() => navigate(`/report/${route}`)}
        >
          <div style={{ maxWidth: "100%" }}>{icon}</div>
          <div>
            <strong>{title}</strong>
          </div>
        </Card>
      </Col>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        {renderBody()}
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default ReportScreen;
